import { render, staticRenderFns } from "./SupportTooltip.vue?vue&type=template&id=39b546c0&scoped=true"
import script from "./SupportTooltip.vue?vue&type=script&lang=ts"
export * from "./SupportTooltip.vue?vue&type=script&lang=ts"
import style0 from "./SupportTooltip.vue?vue&type=style&index=0&id=39b546c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b546c0",
  null
  
)

export default component.exports